import { Button } from "@mui/material";

import { getPrestoneReportUrl } from "./model";

function PrestoneReportLink({ prestoneId }: { prestoneId: string | null }) {
  const reportUrl = prestoneId ? getPrestoneReportUrl(prestoneId) : null;

  if (!reportUrl) {
    return null;
  }

  return (
    <Button
      variant="contained"
      href={reportUrl}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ flexShrink: 0 }}
    >
      View Prestone report
    </Button>
  );
}

export default PrestoneReportLink;
